<template>
   <div class="col-xl-3 col-lg-4 col-md-6">
      <div class="product-bar m-b-30">
         <div class="product-head">
            <img :src="url" class="img-fluid" alt="product">
            <p class="pt-2"><span class="badge font-14" :class="badgeClass">{{product.stock}} disponibles</span></p>
         </div>
         <div class="product-body py-2">
            <div class="row align-items-center">
               <div class="col-12">
                  <div class="d-inline-block">
                     <span class="text-uppercase font-12 f-w-6">Piezas x caja: {{product.box_pieces}}</span>
                  </div>
                  <!--
                  <div class="d-inline-block">
                     <span class="text-uppercase font-12 f-w-6">{{product.brand}}</span>
                  </div>
                  <div class="d-inline-block float-right">
                     Piezas / paquete: {{product.box_pieces}}
                  </div>
                  -->
               </div>
            </div>
            <div class="row align-items-center">
               <div class="col-12">
                  <h5 class="mt-1 mb-3">{{product.name}}</h5>
               </div>
            </div>
            <div class="row align-items-center">
               <div class="col-6">
                  <div class="text-left">
                     <h4 class="mb-1">${{formattedCost}}</h4>
                     <!--
                     <h5 class="f-w-7 mb-0"><sup class="font-12">$</sup>{{formattedCost}}</h5>
                     -->
                  </div>
               </div>
               <div class="col-6">
                  <div class="text-right">
                     <button type="button" class="btn btn-primary-rgba font-18" @click.stop="onCartBtn"><i class="feather icon-shopping-cart"></i></button>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import {Product} from "../../classes/product"
import formatHelper from "@mixins/formatHelper"
export default {
   name: "ProductCard",
   props: {
     product: Product
   },
   mixins: [formatHelper],
   data() {
      return {
         //url: "https://i.ibb.co/wwCRmH7/blog-slide-02.jpg"
         //default_img_url: "https://img.sidi-e.com/4070017.png",
         defaultImage: require('@assets/images/products/product-default-sm-bw.jpg'),
      }
   },
   methods: {
      async onCartBtn(){
         await this.$emit('on-cart-action', this.product.id); 
      }
   },
   computed: {
      formattedCost(){
         return this.fixedFormat(this.stringToFloat(this.product.cost), 2)
      },
      badgeClass(){
         let c = "";
         if(this.product.stock <= 3){
            c = "danger"
         }
         else if(this.product.stock <= 10){
            c = "warning"
         }
         else {
            c = "success"
         }
         return `badge-${c}`;
      },
      url(){
         return Product.getListImgUrl(this.product) ?? this.defaultImage
      }
   }
}
</script>
